// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1nS1v","selects":"Documents_selects__3VYwZ"};